import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import { connect } from "react-redux";

import SplitView from "../../components/splitView";
import { appStateSelectors } from "../../modules/appState";
import { immutableRecords, PropTypeShapes } from "../../types";
import wrapWorkView from "../workView/wrapWorkView";
import OutlineView from "./index";
import selectors from "./selectors";

class OutlineViewLayout extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dragHoverDate: null,
      dragHoverDateString: null,
      dragHoverScreenYPixel: null
    };
    this.updateDragHoverValues = this.updateDragHoverValues.bind();
  }

  updateDragHoverValues = (dragHoverDate, dragHoverDateString, dragHoverScreenYPixel) => {
    this.setState({
      dragHoverDate,
      dragHoverDateString,
      dragHoverScreenYPixel
    });
  };

  renderChildView = (view, siblingCount) => {
    const outlineView = <OutlineView key={view.viewId} viewId={view.viewId} />;

    // If we have already wrapped scrolling, then we just need to render this in a workView
    if (siblingCount > 1) {
      return wrapWorkView(
        outlineView,
        view,
        siblingCount,
        this.props.maxHorizontalViews,
        this.props.maxVerticalViews,
        this.props.layoutDepth,
        this.props.workViewHandlers,
        null,
        this.props.viewLayout.orientation
      );
    }
    return outlineView;
  };

  renderChildren = () => {
    const v = this.props.viewLayout;
    const children = v.children;
    const siblingCount = children.count();
    // const orientation = v.orientation;
    // const wrapScrolling = v.scrollSync;
    // const viewCount = children.count();

    return children
      .map(v => {
        return this.renderChildView(v, siblingCount);
      })
      .toArray();
  };

  renderSplitView = () => {
    let splitProps;
    const children = this.props.viewLayout.get("children");
    const viewCount = children.count();
    splitProps = {
      vertical: false,
      constraints: children.map((c, index) =>
        immutableRecords.SplitConstraintsRecord({
          minSize: c.minSize.height,
          canResize: this.props.canViewResize && index !== viewCount - 1,
          hasDivider: index !== viewCount - 1,
          dividerVisible: index !== viewCount - 1,
          defaultSize: Math.max(c.size.height, 1)
        })
      )
    };

    const childComponents = [];

    const childElements = this.renderChildren();
    childComponents.push(...childElements);

    const createSplitViewWithSize = (
      <SplitView key="outlineLayoutSplitView" {...splitProps}>
        {childComponents}
      </SplitView>
    );

    if (children.count() === 1) {
      const view = children.first();
      return wrapWorkView(
        createSplitViewWithSize,
        view,
        1,
        this.props.maxHorizontalViews,
        this.props.maxVerticalViews,
        this.props.layoutDepth,
        this.props.workViewHandlers,
        null,
        this.props.viewLayout.orientation
      );
    }

    return createSplitViewWithSize;
  };

  render() {
    return this.renderSplitView();
  }
}

const mapStateToProps = (state, props) => {
  const data = selectors.getOutlineViewData(state.present, props.viewIds.first());
  return {
    columns: data.columns,
    width: data.width,
    fontSize: appStateSelectors.getFontSize(state.present)
  };
};

const mapDispatchToProps = _dispatch => {
  return {};
};

OutlineViewLayout.propTypes = {
  viewLayout: PropTypeShapes.viewLayout,
  maxHorizontalViews: PropTypes.number.isRequired,
  maxVerticalViews: PropTypes.number.isRequired,
  canViewResize: PropTypes.bool.isRequired,
  columns: PropTypeShapes.tableColumnList.isRequired,
  width: PropTypes.number.isRequired,
  viewIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  fontSize: PropTypes.number.isRequired,

  // How deep in the layout are we? Used to determine if we will allow splitting further
  layoutDepth: PropTypes.number.isRequired,

  // Handlers to be passed to workView
  workViewHandlers: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(OutlineViewLayout);
